import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Icon from '../../../Assets/Icon/CustomIcon';

const InfoRow = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: '6px 0',
    }}
  >
    <Typography>{label}</Typography>
    <Typography sx={{ color: '#ff6200ff', fontWeight: 500 }}>
      {value}
    </Typography>
  </Box>
);

// 작업허가서 기본정보 조회 컴포넌트
export default function BaseInfo(props) {
  const basicInfo = [
    { label: '공사업체명', value: props.rowData1.CONSTRUCTION_NM },
    { label: '현장책임자', value: props.rowData1.SITE_MANAGER },
    { label: '연락처', value: props.rowData1.SITE_PHONE },
  ];

  const workOverview = [
    {
      label: '작업 일시',
      value: `${dayjs(props.rowData1.WORK_START_DATE).format(
        'YYYY/MM/DD HH:mm'
      )} 
              ~ ${dayjs(props.rowData1.WORK_END_DATE).format(
                'YYYY/MM/DD HH:mm'
              )}`,
    },
    { label: '작업 내용', value: props.rowData1.WORK_DETAIL },
    { label: '작업 인원', value: `${props.rowData1.WORK_MEMBER_NO}명` },
    { label: '작업 장소', value: props.rowData1.WORK_PLACE },
  ];
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
          기본 작성 정보
        </Typography>
        {basicInfo.map((item, idx) => (
          <InfoRow key={idx} label={item.label} value={item.value} />
        ))}
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>작업 개요</Typography>
        {workOverview.map((item, idx) => (
          <InfoRow key={idx} label={item.label} value={item.value} />
        ))}
      </Box>
      {props.rowData1.GUBUN === '요청' && (
        <button
          onClick={() => props.setIsChecked(!props.isChecked)}
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
          }}
        >
          <Icon.CircleCheck
            width={30}
            height={30}
            color={props.isChecked ? '#57B84D' : '#B5B1B1'}
          />
          <Typography
            sx={{
              color: props.isChecked ? '#3A3A3A' : '#B5B1B1',
              fontWeight: props.isChecked ? 'bold' : 'normal',
            }}
          >
            기본 작성 정보를 모두 확인했습니다.
          </Typography>
        </button>
      )}
    </Box>
  );
}
